import { Cognito, Sendum } from '@sendum/core'
import { TPage } from '@sendum/core/src/Cognito/types/TPage'
import {
    PalletSelectorWidget,
    ShipmentSelectorWidget,
    Timeline,
    VisibilityMarkenPublicWidget,
    VisibilityMarkenSharedWidget,
    VisibilityMarkenWidget,
    VisibilityVirtualWidget
} from '@sendum/widgets'
import queryString from 'query-string'
import React from 'react'
import { RouteContext } from 'universal-router'

import { PT300 } from './components/simulators/PT300/PT300'

const renderMarkenWidget = (context: RouteContext): JSX.Element => (
    <VisibilityMarkenWidget
        orderId={context.params.orderId as string}
        openVirtualShipment={name => Sendum.getBrowserHistory().push(`/visibility/virtual/${name}`)}
        openEndToEndShipment={orderId => Sendum.getBrowserHistory().push(`/visibility/${orderId}`)}
        isLiveLegExtended={true}
    />
)

const rootRoute: Cognito.IRoute = {
    path: '/',
    private: 'cognito',
    redirectPath: '/shipments'
}

const landingPagePublicRoute: Cognito.IRoute = {
    path: '/visibility/public',
    private: 'authKey',
    render: () => <VisibilityMarkenPublicWidget />
}

const visibilityWidgetPublicRoute: Cognito.IRoute = {
    path: '/visibility/public/:orderId',
    private: 'authKey',
    render: (context: RouteContext<TPage>) => {
        const deviceId = queryString.parse(context.search as string).deviceId as string

        return <VisibilityMarkenPublicWidget orderId={context.params.orderId as string} deviceId={deviceId} isLiveLegExtended={true} />
    }
}

const visibilityWidgetSharedRoute: Cognito.IRoute = {
    path: '/visibility/shared/:orderId',
    private: 'authKeyShared',
    render: (context: RouteContext) => (
        <VisibilityMarkenSharedWidget
            orderId={context.params.orderId as string}
            openVirtualShipment={name => Sendum.getBrowserHistory().push(`/visibility/virtual/${name}`)}
            openEndToEndShipment={orderId => Sendum.getBrowserHistory().push(`/visibility/shared/${orderId}`)}
            isLiveLegExtended={true}
        />
    )
}

const visibilityWidgetNotificationRoute: Cognito.IRoute = {
    path: '/visibility/notification/:orderId',
    private: 'authToken',
    render: renderMarkenWidget
}

const visibilityWidgetVirtualRoute: Cognito.IRoute = {
    path: '/visibility/virtual/:name',
    private: 'cognito',
    render: (context: RouteContext) => <VisibilityVirtualWidget name={context.params.name as string} />
}

const emptyVisibilityWidgetRoute: Cognito.IRoute = {
    path: '/visibility',
    private: 'cognito',
    isDefault: true,
    render: () => (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 900,
                fontSize: '26px'
            }}
        >
            Please select shipment
        </div>
    )
}

const visibilityWidgetRoute: Cognito.IRoute = {
    path: '/visibility/:orderId',
    private: 'cognito',
    render: renderMarkenWidget
}

const emptyTimelineWidgetRoute: Cognito.IRoute = {
    path: '/timeline',
    private: 'cognito',
    isDefault: true,
    render: () => (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 900,
                fontSize: '26px'
            }}
        >
            Please select shipment
        </div>
    )
}

const timelineWidgetRoute: Cognito.IRoute = {
    path: '/timeline/:orderId',
    private: 'cognito',
    render: (context: RouteContext) => <Timeline masterTrackingNo={context.params.orderId as string} />
}

const shipmentSelectorWidgetRoute: Cognito.IRoute = {
    path: '/shipments',
    private: 'cognito',
    render: () => (
        <ShipmentSelectorWidget
            onShipmentClick={(masterTrackingNo: string) => {
                Sendum.getBrowserHistory().push(`/visibility/${masterTrackingNo}`)
            }}
        />
    )
}

const palletSelectorWidgetRoute: Cognito.IRoute = {
    path: '/pallet',
    private: 'cognito',
    render: () => <PalletSelectorWidget />
}

const simulatorPT300Route: Cognito.IRoute = {
    path: '/simulator/pt300',
    private: 'cognito',
    render: () => <PT300 />
}

export const routes: Map<string, Cognito.IRoute> = new Map([
    ['root', rootRoute],
    ['landingPage', landingPagePublicRoute],
    ['publicVisibility', visibilityWidgetPublicRoute],
    ['sharedVisibility', visibilityWidgetSharedRoute],
    ['notificationVisibility', visibilityWidgetNotificationRoute],
    ['virtualVisibility', visibilityWidgetVirtualRoute],
    ['visibility', visibilityWidgetRoute],
    ['emptyVisibility', emptyVisibilityWidgetRoute],
    ['timeline', timelineWidgetRoute],
    ['emptyTimeline', emptyTimelineWidgetRoute],
    ['shipmentSelectorWidgetRoute', shipmentSelectorWidgetRoute],
    ['palletSelectorWidgetRoute', palletSelectorWidgetRoute],
    ['simulatorPT300', simulatorPT300Route]
])
